document.querySelectorAll(".multiple-splider").forEach(function(element) {
	new Splide( '.splide-' + element.getAttribute('unique_id'), {
		type   : 'loop',
		perPage: element.getAttribute('posts_to_display'),
		perMove: 1,
		clones: 0,
		gap: '20px',
		breakpoints: {
			767: {
				perPage: 1,
			},
		}
	} ).mount();
});
